const FishToWhiteTransition = () => (
  <svg
    className="HomePageImageOverlaySVG"
    style={{
      position: 'absolute',
      top: '100vh',
      left: 0,
      width: '100%',
      height: '16vh',
      zIndex: 2,
      pointerEvents: 'none',
      display: 'block',
      filter: 'blur(2.5px)'
    }}
    viewBox="0 0 100 16"
    preserveAspectRatio="none"
  >
    <defs>
      <linearGradient id="whiteFade" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="rgba(255,255,255,0.15)" />
        <stop offset="20%" stopColor="rgba(255,255,255,0.35)" />
        <stop offset="50%" stopColor="rgba(255,255,255,0.7)" />
        <stop offset="85%" stopColor="rgba(255,255,255,0.95)" />
        <stop offset="100%" stopColor="rgba(255,255,255,1)" />
      </linearGradient>
    </defs>
    <path d="M0,2 Q25,10 50,8 Q75,6 100,12 L100,16 L0,16 Z" fill="url(#whiteFade)" />
  </svg>
);

export default FishToWhiteTransition;
